'use client';

import { useEffect } from 'react';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import useVelocityClient from './useVelocityClient';
import useVelocityClientIsReady from './useVelocityClientIsReady';
import useLazySubAccounts from './useLazySubAccounts';
import useWalletIsConnected from './useWalletIsConnected';
// import useInterval from './useInterval';
// import Env from 'src/environmentVariables/EnvironmentVariables';

const useUserStatsAccount = () => {
	const setState = useVelocityStore((s) => s.set);
	const velocityClient = useVelocityClient();
	const velocityClientIsReady = useVelocityClientIsReady();
	const connected = useWalletIsConnected();
	const connection = useVelocityStore((s) => s.connection.current);
	const subAccounts = useLazySubAccounts();

	const setUserStatsAccount = async () => {
		if (velocityClientIsReady && connection && connected) {
			try {
				const userStatsAccount = velocityClient?.userStats?.getAccount();
				setState((s) => {
					s.userStatsAccount = userStatsAccount;
				});
			} catch {
				// velocityClient.userStats?.getAccount() throws an error if user stats account is uninitialized
				console.log('User stats account not found');
			}
		} else {
			setState((s) => {
				s.userStatsAccount = undefined;
			});
		}
	};

	// TODO: it will be better if user stats account subscriber takes in a callback that updates the velocity store on account update
	// useInterval(setUserStatsAccount, Env.pollingFrequencyMs);

	useEffect(() => {
		setUserStatsAccount();
	}, [
		velocityClientIsReady,
		connection,
		connected,
		subAccounts,
		velocityClient?.authority,
	]);
};

export default useUserStatsAccount;
